import GolfballTowerSVG from "../../assets/images/GolfballTower.svg";
import WaterTowerSVG from "../../assets/images/WaterTower.svg";
import StandpipeTowerSVG from "../../assets/images/StandpipeTower.svg";
import LegacyCylinderSVG from "../../assets/images/LegacyCylinder.svg";
import { TankDisplayStyleEnum } from "../../common/enums/TankDisplayStyleEnum";

export type TankDisplayStyleDefinition = {
    id: TankDisplayStyleEnum;
    name: string;
    imageURL: string;
    imageX: string;
    imageY: string;
    imageWidth: string;
    imageHeight: string;
    graphX: string;
    graphY: string;
    graphWidth: string;
    graphHeight: string;
    tags?: Array<string>;
};

export const tankDisplayStyleDefinitions: Array<TankDisplayStyleDefinition> = [
    {
        id: TankDisplayStyleEnum.LegacyCylinder,
        name: "Cylinder",
        imageURL: LegacyCylinderSVG,
        imageX: "0",
        imageY: "0",
        imageWidth: "1000",
        imageHeight: "1000",
        graphX: "0",
        graphY: "0",
        graphWidth: "1000",
        graphHeight: "1000",
        tags: ["Oil", "Water", "Ground Level"]
    },
    {
        id: TankDisplayStyleEnum.SpheroidTower,
        name: "Spheroid Tower",
        imageURL: GolfballTowerSVG,
        imageX: "0",
        imageY: "0",
        imageWidth: "1000",
        imageHeight: "1000",
        graphX: "420",
        graphY: "130",
        graphWidth: "160",
        graphHeight: "325",
        tags: ["Water", "Elevated"]
    },
    {
        id: TankDisplayStyleEnum.MultiLegTower,
        name: "Multi-Leg Tower",
        imageURL: WaterTowerSVG,
        imageX: "0",
        imageY: "0",
        imageWidth: "1000",
        imageHeight: "1000",
        graphX: "420",
        graphY: "140",
        graphWidth: "174",
        graphHeight: "252",
        tags: ["Water", "Elevated"]
    },
    {
        id: TankDisplayStyleEnum.Standpipe,
        name: "Standpipe",
        imageURL: StandpipeTowerSVG,
        imageX: "0",
        imageY: "0",
        imageWidth: "1000",
        imageHeight: "1000",
        graphX: "420",
        graphY: "130",
        graphWidth: "144",
        graphHeight: "774",
        tags: ["Water", "Ground Level"]
    }
];

export const tankDisplayStyleDefinitionsMap: Record<TankDisplayStyleEnum, TankDisplayStyleDefinition> = tankDisplayStyleDefinitions.reduce((acc, definition) => {
    acc[definition.id] = definition;
    return acc;
}, {} as Record<TankDisplayStyleEnum, TankDisplayStyleDefinition>);

/**
 * Resolves a display style to its definition. Missing or unrecognized values
 * (e.g. legacy/unknown values from the API) resolve to the legacy cylinder.
 */
export function getTankDisplayStyleDefinition(style: TankDisplayStyleEnum | null | undefined): TankDisplayStyleDefinition {
    return (style != null ? tankDisplayStyleDefinitionsMap[style] : undefined)
        ?? tankDisplayStyleDefinitionsMap[TankDisplayStyleEnum.LegacyCylinder];
}
